/* eslint-disable react/no-render-return-value */
import { Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { ReactQueryDevtools } from 'react-query/devtools'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { QueryClientProvider } from 'react-query'
import { HashRouter } from 'react-router-dom'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon'
import { LinearProgress } from '@mui/material'
import i18n from 'i18next'

import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import '@fontsource/roboto/900.css'
import { queryClient } from 'api'
import { theme } from './theme'
import 'assets/css/main.css'
import App from './App'
import './i18n'
import { I18nSupportedFormat } from 'types/enums'
import KeycloakService from 'services/KeycloakService'

i18n?.services?.formatter?.add(
  I18nSupportedFormat.LocalNumber,
  (value, lng, options) => new Intl.NumberFormat('el-GR').format(value)
)
i18n?.services?.formatter?.add(
  I18nSupportedFormat.LocalCurrency,
  (value, lng, options) =>
    value.toLocaleString('el-GR', {
      style: 'currency',
      currency: 'EUR',
    })
)

const container = document.getElementById('root')
const root = createRoot(container)

const renderApp = () =>
  root.render(
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterLuxon}>
            <CssBaseline />
            <Suspense fallback={<LinearProgress />}>
              <App />
            </Suspense>
          </LocalizationProvider>
        </ThemeProvider>
      </HashRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )

KeycloakService.initKeycloak(renderApp)
